import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconAnswerQuestion = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon/answer/question",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Subtract",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.87729 13.0568V11.289H7.53979V13.0568H5.87729ZM6.70854 3.05103C5.6331 3.05103 4.75701 3.94617 4.69909 5.05218H3.03516C3.0935 2.95372 4.72064 1.2832 6.70854 1.2832C8.73314 1.2832 10.3835 3.01598 10.3835 5.16885C10.3835 6.36455 9.71031 7.02158 8.99917 7.6784L8.93417 7.73836C8.27274 8.34815 7.58854 8.97893 7.54227 10.0551H5.87856C5.8947 9.32035 6.0634 8.78114 6.30617 8.35759C6.56246 7.91047 6.90534 7.58492 7.25731 7.2908C7.34073 7.22109 7.42534 7.15285 7.50964 7.08486L7.50972 7.08479C8.12374 6.58958 8.72104 6.10786 8.72104 5.16885C8.72104 4.00981 7.82154 3.05103 6.70854 3.05103Z",
			fill: "#FFB155"
		})
	})
});
export default SvgIconAnswerQuestion;
